export default __webpack_public_path__ + "static/media/tianandistrict.92b5b5db.jpg";